// Generated from src/img/svg/elevator.svg

export const Elevator = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M0 0h24v24H0Z" style={{ fill: "none" }} />
      <path
        d="m15.2 10.1 1.6 1.6-.5.6-1.1-1.1-1 1.1-.6-.6z"
        style={{ fill: "#353535" }}
      />
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m-.7 20.2H7.1a.9.9 0 0 1-.9-.9V4.7a.9.9 0 0 1 .9-.9h4.2Zm6.5-.9a.9.9 0 0 1-.9.9h-4.3V3.8h4.3a.9.9 0 0 1 .9.9Zm-7.5-8.4-.5-.5-1.1 1-1-1-.6.5 1.6 1.6Z"
        style={{ fill: "#353535" }}
      />
    </svg>
  );
};
